import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import {
  MultipleWizardPage,
  SingleWizardPage,
  ProtectionChoicePage,
} from "../pages/wizard";
import { HelpPageRouter } from "./HelpPageRouter";
import { useRestoreSession } from "../hooks";

export const WizardRouter = () => {
  useRestoreSession();

  return (
    <Routes>
      <Route path="help/*" element={<HelpPageRouter />} />

      <Route
        path="wizard/protection-choice"
        element={<ProtectionChoicePage />}
      />

      <Route path="wizard/multiple" element={<MultipleWizardPage />} />

      <Route path="wizard/single" element={<SingleWizardPage />} />

      <Route path="*" element={<Navigate to="wizard/protection-choice" />} />
    </Routes>
  );
};
